(function() {
    /* ==== v34 (Aug 16, 2026): debossed wordmark gets its own ramp ====
       - The header wordmark (.ormuth-stamped-wordmark, snippets/
         header-logo-wordmark.liquid) is glyphs-as-recesses: thin letter stems
         can't read with the plates' tone-on-tone depth shrink, so it uses
         applyWordmarkRamp — same math family, deeper floor (rev 3c constants,
         approved by Joe from the Brand & Media rev3/3b/3c previews).
       - Same one-shot pixel sampling; each element samples its own backdrop.
       ==== v32 (Aug 10, 2026): v31, frozen at page load ====
       - Samples the backdrop ONCE when the page opens (with retries while
         the hero image finishes painting), then stays static for the visit.
       - No re-sampling on scroll, no intervals, no drawer/overlay bleed.
       - Swapping the hero image still auto-matches on the next page load.
       ==== v31 (July 24, 2026): v27's rendering with REAL EYES ====
       - Rim strokes, letter fills, and flood colors are computed by v27's own
         ramp from a color SAMPLED FROM THE ACTUAL PIXELS behind the icon
         (image, video frame, background-image, or solid color).
       - The recess floor is semi-transparent dark glass: the page shows
         through inside the marks, pressed into shadow. Depth adapts to the
         material's lightness (tone-on-tone on white, full v27 depth on dark).
       - Falls back to v27's solid-background walk if sampling fails.
       Approved by Joe from Brand & Media/Previews/Hallmark Cart v31 Preview.html
       Previous version: snippets/icon-header-cart-v27-backup.liquid */

    function parseColor(c) {
      if (!c) return null;
      c = c.trim();
      var alpha = c.match(/^rgba\([^)]*[,/]\s*([0-9.]+)\s*\)$/i);
      if (alpha && parseFloat(alpha[1]) <= 0.01) return null;
      if (c === 'transparent') return null;
      if (c.charAt(0) === '#') {
        if (c.length === 4) return [parseInt(c[1]+c[1],16), parseInt(c[2]+c[2],16), parseInt(c[3]+c[3],16)];
        if (c.length === 7) return [parseInt(c.substr(1,2),16), parseInt(c.substr(3,2),16), parseInt(c.substr(5,2),16)];
      }
      var m = c.match(/rgba?\(\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*(\d+)/);
      if (m) return [parseInt(m[1],10), parseInt(m[2],10), parseInt(m[3],10)];
      return null;
    }
    function rgbHex(r,g,b) { function h(v) { v=Math.max(0,Math.min(255,Math.round(v))); var s=v.toString(16); return s.length===1?'0'+s:s; } return '#'+h(r)+h(g)+h(b); }
    function ratio(a,b,w) { return [a[0]*w+b[0]*(1-w), a[1]*w+b[1]*(1-w), a[2]*w+b[2]*(1-w)]; }
    function lum(rgb) { return rgb[0]*0.2126 + rgb[1]*0.7152 + rgb[2]*0.0722; }
    var BLACK=[36,26,18], WHITE=[245,233,220]; /* warm ink & warm paper — pure b/w greyed out muted backdrops */
    /* v37.1 (Joe, Aug 17: "the hallmarks arent matching so well they are just
       gray"): on very light, low-chroma bars (white/cream) the BLACK mixes
       desaturate into putty-gray. Bias such backdrops up to 30% toward the brand
       tan BEFORE ramping so the stamps stay warm. Dark or colorful backdrops
       (espresso bar, plaster hero) pass through untouched: L≤190 or chroma>42. */
    var WARMTAN=[199,158,117];
    function warmBias(bg) {
      var L = lum(bg);
      if (L <= 190) return bg;
      var chroma = Math.max(bg[0],bg[1],bg[2]) - Math.min(bg[0],bg[1],bg[2]);
      if (chroma > 42) return bg;
      var w = Math.min(1, (L - 190) / 55) * 0.30;
      return ratio(WARMTAN, bg, w);
    }

    /* v37.5 (Joe, Aug 17: "the embossing doesnt look as good... your preview is much
       nicer"). Diagnosed: the recess floor was painted OPAQUE (stop-opacity 1), so on
       a photographic backdrop — his mottled plaster hero, a textured bar — the inside
       of every mark became a flat dead patch that did not share the wall's grain. A
       real deboss is the SAME material, just lower: the texture must continue through
       the recess. That is what this file's own v31 header describes ("semi-transparent
       dark glass: the page shows through inside the marks") and it had regressed.
       Fix: paint the floor as warm ink at partial alpha instead of an opaque tint,
       choosing alpha so the COMPOSITE equals the old opaque tone exactly — same
       approved colour, but the backdrop now modulates through it.
         opaque target: bg*f      translucent: BLACK*a + bg*(1-a)
         => a = (1-f) * L(bg) / (L(bg) - L(BLACK))
       Falls back to opaque on backdrops at/below ink luminance (nothing to darken). */
    /* A/B SWITCH (Joe is comparing on his own screen — my previews render at 2x his
       pixel density and always flatter the effect, so this has to be judged live).
         false = every mark's recess floor is an OPAQUE tint  <- the original look
         true  = plates + emblem get a translucent ink floor so the backdrop's
                 texture continues through the recess (glyphs stay solid regardless;
                 see the v37.6 note — thin stems break up if the floor goes glassy)
       Flip this one word to switch the whole site. */
    var ORMUTH_GLASS_PLATES = false;
    function floorAlpha(bg, f) {
      if (!ORMUTH_GLASS_PLATES) return null;
      var Lb = lum(bg), Lk = lum(BLACK);
      if (Lb <= Lk + 12) return null;
      var a = (1 - f) * Lb / (Lb - Lk);
      return Math.max(0, Math.min(0.95, a));
    }
    function setFloor(setAll, sel, bg, f) {
      var a = floorAlpha(bg, f);
      if (a === null) {
        setAll(sel, 'stop-color', rgbHex(bg[0]*f, bg[1]*f, bg[2]*f));
        setAll(sel, 'stop-opacity', '1');
      } else {
        setAll(sel, 'stop-color', rgbHex.apply(null, BLACK));
        setAll(sel, 'stop-opacity', a.toFixed(3));
      }
    }

    function applyRamp(icon, bg) {
      if (!bg) return;
      bg = warmBias(bg);
      var bgLum = lum(bg);
      var letterTarget = bgLum > 128 ? BLACK : WHITE;
      var d = bgLum <= 110 ? 1 : Math.max(0.62, 1 - (bgLum - 110) / 135 * 0.66);
      function dk(w) { return 1 - (1 - w) * d; }
      var ramp = {
        outline:       rgbHex.apply(null, ratio(bg, BLACK, dk(CX(0.45)))),
        shadowStrong:  rgbHex.apply(null, ratio(bg, BLACK, dk(CX(0.15)))),
        shadowSoft:    rgbHex.apply(null, ratio(bg, BLACK, dk(CX(0.45)))),
        letter:        rgbHex.apply(null, ratio(bg, letterTarget, dk(0.85))),
        highlightMid:  rgbHex.apply(null, ratio(bg, WHITE, CX(0.50))),
        highlightSoft: rgbHex.apply(null, ratio(bg, WHITE, CX(0.30)))
      };
      function setAll(sel, attr, val) { icon.querySelectorAll(sel).forEach(function(el){ el.setAttribute(attr, val); }); }
      /* recess plate: the backdrop's own color, gently dimmed — hue-true.
         (scaling RGB keeps a pink wall pink and amber glass amber; mixing
          toward black/ink either greyed it or went too dark) */
      var ft = 1 - FL(0.24) * d, fb = 1 - FL(0.15) * d;
      setFloor(setAll, '.ohc-recess-top', bg, ft);
      setFloor(setAll, '.ohc-recess-bot', bg, fb);
      setAll('.ohc-outline','stroke',ramp.outline);
      setAll('.ohc-inner-hi','stroke',ramp.highlightMid);
      setAll('.ohc-inner-sh','stroke',ramp.shadowSoft);
      setAll('.ohc-stamped','fill',ramp.letter);
      setAll('.ohc-fl-shadow','flood-color',ramp.shadowStrong);
      setAll('.ohc-fl-highlight','flood-color',ramp.highlightMid);
      setAll('.ohc-fl-em-hi','flood-color',ramp.highlightSoft);
      setAll('.ohc-fl-em-sh','flood-color',ramp.shadowStrong);
      setAll('.ohc-fl-em-deep','flood-color',ramp.shadowStrong);
    }

    /* wordmark ramp — rev 3c: deeper floor + inner walls for thin glyph stems */
    function applyWordmarkRamp(icon, bg) {
      if (!bg) return;
      bg = warmBias(bg);
      /* v34.2: liquid's {% increment %} is render-scoped, so every header
         instance ships id "...0" and the VISIBLE svg painted from the HIDDEN
         mobile instance's defs (which ramp white → washed-out outlines).
         De-dup ids per instance once, repointing fill/filter to its own defs. */
      var bgLum = lum(bg);
      var d = bgLum <= 110 ? 1 : Math.max(0.78, 1 - (bgLum - 110) / 135 * 0.38);
      function dk(w) { return 1 - (1 - w) * d; }
      function setAll(sel, attr, val) { icon.querySelectorAll(sel).forEach(function(el){ el.setAttribute(attr, val); }); }
      /* v37.6 (Joe, Aug 17): the glass floor is for PLATES ONLY. Applied to the
         wordmark it made ORMUTH "bareley look stamped in" — and the reason is the
         oldest rule in this system (see the doc's error log #1): a plate is a large
         area whose floor can be translucent because the wall's grain reads THROUGH
         it, but a glyph stem is ~2px wide, so the floor IS the whole mark. Make it
         translucent and two things break at once: the letter loses tonal body, and
         backdrop noise runs through the stem and chews up the edges the deboss
         depends on. Letters keep the solid, deeper floor (0.29/0.18 vs the plates'
         0.24/0.15 — that gap exists for exactly this reason). Same applies to the
         thin menu bars, which share these owm-* hooks. */
      var ft = 1 - FL(0.29) * d, fb = 1 - FL(0.18) * d;
      setAll('.owm-floor-top','stop-color', rgbHex(bg[0] * ft, bg[1] * ft, bg[2] * ft));
      setAll('.owm-floor-top','stop-opacity','1');
      setAll('.owm-floor-bot','stop-color', rgbHex(bg[0] * fb, bg[1] * fb, bg[2] * fb));
      setAll('.owm-floor-bot','stop-opacity','1');
      setAll('.owm-outline','stroke', rgbHex.apply(null, ratio(bg, BLACK, dk(CX(0.40)))));
      setAll('.owm-fl-innersh','flood-color', rgbHex.apply(null, ratio(bg, BLACK, dk(CX(0.26)))));
      setAll('.owm-fl-innerlt','flood-color', rgbHex.apply(null, ratio(bg, WHITE, CX(0.46))));
      setAll('.owm-fl-outsh','flood-color', rgbHex.apply(null, ratio(bg, BLACK, dk(CX(0.45)))));
      setAll('.owm-fl-outlt','flood-color', rgbHex.apply(null, ratio(bg, WHITE, CX(0.50))));
    }
    function dedupIds(icon) {
      if (icon.__owmUid) return;
      {
        var uid = (window.__owmUidCounter = (window.__owmUidCounter || 0) + 1);
        icon.__owmUid = uid;
        icon.querySelectorAll('linearGradient[id], filter[id], mask[id]').forEach(function(def) {
          var old = def.id, neu = old + 'u' + uid;
          def.id = neu;
          icon.querySelectorAll('[fill="url(#' + old + ')"]').forEach(function(el) { el.setAttribute('fill', 'url(#' + neu + ')'); });
          icon.querySelectorAll('[filter="url(#' + old + ')"]').forEach(function(el) { el.setAttribute('filter', 'url(#' + neu + ')'); });
          icon.querySelectorAll('[stroke="url(#' + old + ')"]').forEach(function(el) { el.setAttribute('stroke', 'url(#' + neu + ')'); });
          icon.querySelectorAll('[mask="url(#' + old + ')"]').forEach(function(el) { el.setAttribute('mask', 'url(#' + neu + ')'); });
        });
      }
    }
    function rampFor(icon) {
      return (icon.classList && icon.classList.contains('ormuth-stamped-wordmark')) ? applyWordmarkRamp : applyRamp;
    }

    /* ---- pixel sampler ---- */
    var sampleCanvas = document.createElement('canvas');
    sampleCanvas.width = 24; sampleCanvas.height = 8;
    var sctx = sampleCanvas.getContext('2d', { willReadFrequently: true });
    var imgCache = {};

    function averageCanvas() {
      try {
        var dta = sctx.getImageData(0, 0, 24, 8).data;
        var r=0,g=0,b=0,n=0;
        for (var i=0;i<dta.length;i+=4) { r+=dta[i]; g+=dta[i+1]; b+=dta[i+2]; n++; }
        return [r/n, g/n, b/n];
      } catch(e) { return null; }
    }
    function coverSourceRect(natW, natH, boxW, boxH, fracX, fracY, fracW, fracH) {
      var scale = Math.max(boxW/natW, boxH/natH);
      var visW = boxW/scale, visH = boxH/scale;
      var offX = (natW-visW)/2, offY = (natH-visH)/2;
      return [offX+fracX*visW, offY+fracY*visH, fracW*visW, fracH*visH];
    }
    function sampleMedia(el, iconRect, cb) {
      var er = el.getBoundingClientRect();
      if (!er.width || !er.height) return cb(null);
      var fx = (iconRect.left-er.left)/er.width, fy=(iconRect.top-er.top)/er.height;
      var fw = iconRect.width/er.width, fh=iconRect.height/er.height;
      fx=Math.max(0,Math.min(1,fx)); fy=Math.max(0,Math.min(1,fy));
      fw=Math.max(0.02,Math.min(1-fx,fw)); fh=Math.max(0.02,Math.min(1-fy,fh));
      function draw(source, natW, natH) {
        var s = coverSourceRect(natW, natH, er.width, er.height, fx, fy, fw, fh);
        try { sctx.clearRect(0, 0, 24, 8); sctx.drawImage(source, s[0], s[1], s[2], s[3], 0, 0, 24, 8); cb(averageCanvas()); }
        catch(e) { cb(null); }
      }
      if (el.tagName === 'VIDEO') {
        if (el.videoWidth) draw(el, el.videoWidth, el.videoHeight); else cb(null);
      } else if (el.tagName === 'IMG') {
        var imgUrl = el.currentSrc || el.src;
        if (!imgUrl) return cb(null);
        if (imgCache[imgUrl] && imgCache[imgUrl].complete) {
          draw(imgCache[imgUrl], imgCache[imgUrl].naturalWidth, imgCache[imgUrl].naturalHeight);
          return;
        }
        var cleanImg = new Image();
        cleanImg.crossOrigin = 'anonymous';
        cleanImg.onload = function() { imgCache[imgUrl] = cleanImg; draw(cleanImg, cleanImg.naturalWidth, cleanImg.naturalHeight); };
        cleanImg.onerror = function() { cb(null); };
        cleanImg.src = imgUrl;
      } else {
        var bi = getComputedStyle(el).backgroundImage;
        var m = bi && bi.match(/url\("?([^")]+)"?\)/);
        if (!m) return cb(null);
        var url = m[1];
        if (imgCache[url] && imgCache[url].complete) { draw(imgCache[url], imgCache[url].naturalWidth, imgCache[url].naturalHeight); return; }
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function() { imgCache[url]=im; draw(im, im.naturalWidth, im.naturalHeight); };
        im.onerror = function() { cb(null); };
        im.src = url;
      }
    }
    /* v37.2 (Aug 17): banner sections layer a gradient/translucent scrim pane
       (.banner-overlay) over the hero image. Those scrims are dressing, not the
       material — treating one as the backdrop nulls the sample (gradients have
       no url) or reads a phantom dark. Skip them and keep walking to the real
       image/solid beneath. "Solid enough" = no alpha, or alpha ≥ 0.9. */
    function isSolidEnough(bc) {
      if (!bc || bc === 'rgba(0, 0, 0, 0)' || bc === 'transparent') return false;
      var am = bc.match(/rgba\([^)]*[,/]\s*([0-9.]+)\s*\)/);
      return !am || parseFloat(am[1]) >= 0.9;
    }
    function findBackdrop(icon) {
      var r = icon.getBoundingClientRect();
      if (!r.width) return null;
      var els = document.elementsFromPoint(r.left + r.width/2, r.top + r.height/2);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el === icon || icon.contains(el)) continue;
        if (el.contains(icon)) {
          var st0 = getComputedStyle(el);
          if (st0.backgroundImage && st0.backgroundImage !== 'none' && st0.backgroundImage.indexOf('url(') !== -1) return el;
          if (isSolidEnough(st0.backgroundColor)) return el;
          continue;
        }
        if (el.tagName === 'VIDEO' || el.tagName === 'IMG') return el;
        var st = getComputedStyle(el);
        if (st.backgroundImage && st.backgroundImage !== 'none' && st.backgroundImage.indexOf('url(') !== -1) return el;
        if (isSolidEnough(st.backgroundColor)) return el;
      }
      return null;
    }
    /* v27's original solid-color walk — the safety net */
    function findBgWalk(icon) {
      var inline = icon.style.getPropertyValue('--ormuth-cart-bg').trim();
      if (inline) return inline;
      var attr = icon.getAttribute('data-cart-bg');
      if (attr) return attr;
      var el = icon.parentElement;
      while (el) {
        var bg = getComputedStyle(el).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
        if (el === document.body) break;
        el = el.parentElement;
      }
      return getComputedStyle(document.body).backgroundColor || '#F5F2EF';
    }

    var current = {};
    /* ===== v38: LOCKED COLOUR (Joe, Aug 17: "permanent, no freekin sampling that
       glitches... it should sample in editor when i change picture but once picture
       is decided it should be permanent till changed").
       Storefront: NO pixel sampling at all. Every mark ramps from one fixed backdrop
       colour supplied by the theme editor (data-ormuth-bg on #SiteHeader), applied
       once, synchronously, identically on every load. Nothing async, nothing to race,
       nothing to re-paint — the entire class of colour glitches is gone by
       construction: no hero decode timing, no scroll position, no slideshow frame.
       Theme editor (Shopify.designMode): sampling still runs, so when he swaps the
       picture he SEES the matched colours and the badge tells him the hex to paste
       into the setting. Deciding = pasting that hex. ===== */
    /* v39 (Sep 24 2026, Joe: "the stamp color now on mobile isnt great").
       Desktop and mobile run different hero photos, so the plaster behind the
       marks differs (desktop #B68C74, mobile #A78671). data-ormuth-bg-mb, when
       the theme editor supplies it, wins below 950px. Falls back to the single
       desktop colour when blank, so nothing changes until the field is filled. */
    var ORMUTH_MB_MQ = window.matchMedia ? window.matchMedia('(max-width: 949px)') : null;
    function lockedBg() {
      var h = document.getElementById('SiteHeader');
      if (!h) return null;
      var v = null;
      if (ORMUTH_MB_MQ && ORMUTH_MB_MQ.matches) v = h.getAttribute('data-ormuth-bg-mb');
      if (!v) v = h.getAttribute('data-ormuth-bg');
      return v ? parseColor(v.trim()) : null;
    }

    /* v42 (Sep 24 2026, Joe: "your changes taken out pic def looks better").
       Two same-day additions are removed here:
         v40 markContrast/CX mixed the mobile shadows up to 1.4x darker.
         v41 rescaleStampFilters multiplied the cart mark's filter offsets and
             blurs by desktopWidth / renderedWidth (2.0 on a phone).
       Together with the Liquid-side hm_k factor they made the phone engraving
       1.55x to 2x fatter and darker relative to the letters, which is what read
       as "not sharp". Phones draw 2 or 3 device pixels per CSS pixel, so the
       original proportional relief renders cleanly there; the honest remaining
       difference is only that the mobile Logo size slider (110) makes the marks
       35% smaller than desktop (170). Verified in a real browser at 390px / 3x.
       The ramp weights below are used as written on every device. */
    function CX(w) { return w; }
    /* v42.1 (Sep 24 2026, Joe: "make the inside color lighter so it matches
       better"). The recess floor (the inside of every letter and plate) is the
       backdrop colour dimmed by these weights. On phones the weights are halved
       so the floor sits closer to the plaster; desktop is unchanged. One number
       to tune: 1 = same as desktop, 0.35 = current (Joe picked the lightest of four), lower = lighter. */
    var ORMUTH_FLOOR_MB = 0.35;
    function FL(w) { return (ORMUTH_MB_MQ && ORMUTH_MB_MQ.matches) ? w * ORMUTH_FLOOR_MB : w; }
    var IN_EDITOR = !!(window.Shopify && window.Shopify.designMode);

    function refresh(icon, key, instant) {
      var apply = rampFor(icon);
      dedupIds(icon);
      /* v38.3 (Sept 16): an explicit per-mark pin beats the sitewide locked
         colour, restoring the v27 rule. No header mark carries a pin, so the
         lock still governs the whole header; pinned marks (the video hallmarks
         sit on a fixed grey sky) keep their own base instead of being repainted
         with the header's colour. */
      var pinned = icon.style.getPropertyValue('--ormuth-cart-bg').trim() || icon.getAttribute('data-cart-bg');
      if (pinned) { var pc = parseColor(pinned); if (pc) { apply(icon, pc); return; } }
      if (!IN_EDITOR) {                       /* live site: fixed colour, one pass */
        var lk = lockedBg();
        if (lk) { apply(icon, lk); return; }
        /* v38.1 FIX: with no colour set, v38 returned here and did nothing — so every
           mark fell back to the palette baked into the snippets (tuned to an older
           hero) and stopped matching any page. Now a blank setting simply falls
           through to the single-shot sample, i.e. exactly the v37.8 behaviour that
           worked. Setting the colour still makes it permanent and sampling-free. */
      }
      var el = findBackdrop(icon);
      if (!el) { var wc = parseColor(findBgWalk(icon)); if (wc) apply(icon, wc); return; }
      var st = getComputedStyle(el);
      var isMedia = el.tagName==='VIDEO' || el.tagName==='IMG' || (st.backgroundImage && st.backgroundImage!=='none');
      if (!isMedia) {
        var c = parseColor(st.backgroundColor);
        if (c) apply(icon, c);
        return;
      }
      sampleMedia(el, icon.getBoundingClientRect(), function(rgb) {
        if (!rgb) {
          /* v34.1: a failed sample must never clobber an earlier good one —
             at boot the first crossOrigin fetch of the hero can lose a cache
             race and error AFTER the retries already painted the true color
             (froze the header wordmark white on load, Aug 16). */
          if (current[key]) return;
          /* v37.2 (Aug 17): when the backdrop is MEDIA that failed to sample
             (slow hero, cache race), do NOT fall back to the solid walk — with
             a transparent bar it lands on the white body and froze the whole
             lockup pale ("again on home page its messed up"). The baked warm
             palette in the snippets is the correct fallback: keep it, and
             re-ramp once when the media actually finishes loading. */
          if (el.tagName === 'IMG' && !el.complete && !el.__ormuthLoadHook) {
            el.__ormuthLoadHook = true;
            el.addEventListener('load', function(){ refreshAll(true); }, { once: true });
          }
          return;
        }
        var prev = current[key];
        var next = (prev && !instant) ? ratio(rgb, prev, 0.4) : rgb;
        current[key] = next;
        apply(icon, next);
      });
    }
    /* v35 (Aug 16, 2026): STATIC COLOR MODE, per Joe. The live pixel-sampling
       ramp was glitchy (a failed hero fetch could freeze the fallback palette),
       so the current hero's palette is baked into the snippets as literal
       colors and ramping is disabled. To re-enable dynamic matching, set
       ORMUTH_STATIC_COLORS = false. Cart-count logic below stays active. */
    var ORMUTH_STATIC_COLORS = false; /* v37: dynamic re-enabled at Joe's request — sample ONCE per page load, freeze for the visit. All known failure modes fixed: per-instance ids (dedupIds), no retries past 2.5s, failed samples never overwrite good ones. */
    /* v37.3 (Joe, Aug 17: "it still turns white"): the boot retries re-sample at
       400/1000/2500ms. If the visitor has ALREADY SCROLLED by then (or reloaded
       mid-page with scroll restoration), a transparent bar floats over the white
       content grid - the retry sampled that white and froze it for the visit.
       Rule: on pages whose bar is transparent, never sample while scrolled.
       Solid painted bars are scroll-independent and stay free to sample. */
    /* v38.2: the FIRST pass must never be blocked. This guard exists to stop LATER
       re-ramps (the late-hero load hook, resize) from sampling the white page body
       while scrolled on a transparent-bar page. But v37.8 removed the timed retries,
       so the boot sample became the only sample — and on a reload that restores
       scroll position, this guard silently blocked it and every mark stayed on the
       baked palette. Boot always samples; everything after it is still guarded. */
    var ORMUTH_FIRST_PASS = true;
    function scrollUnsafe() {
      if (ORMUTH_FIRST_PASS) return false;
      if (window.scrollY <= 40) return false;
      var inner = document.getElementById('SiteHeaderInner');
      if (!inner) return false;
      return !isSolidEnough(getComputedStyle(inner).backgroundColor);
    }
    function refreshAll(instantAll) {
      if (ORMUTH_STATIC_COLORS) return;
      if (scrollUnsafe()) return;
      /* v34: cart hallmarks via applyRamp, header wordmark via applyWordmarkRamp
         (rampFor decides per element). */
      document.querySelectorAll('.icon.icon-header-cart, .ormuth-stamped-wordmark, .ormuth-crownmark, .ormuth-archmark, .ormuth-diamondmark, .ormuth-mobmark, .ormuth-emblemmark, .ormuth-vidmark').forEach(function(icon, i) { refresh(icon, 'i'+i, instantAll === true); });
    }
    window.OrmuthHallmarks = window.OrmuthHallmarks || {};
    window.OrmuthHallmarks.version = 'v42-proportional';
    window.OrmuthHallmarks.refresh = refreshAll;
    if (!window.__ormuthHallmarkPositionListener) {
      window.__ormuthHallmarkPositionListener = true;
      document.addEventListener('ormuth:hallmark-position-change', function() { refreshAll(true); });
      document.addEventListener('shopify:section:load', function() { setTimeout(function(){ refreshAll(true); }, 60); });
      /* v38: in the editor only, report the sampled backdrop so Joe can paste it into
         Header > "Header marks: locked backdrop colour" and make it permanent. */
      if (window.Shopify && window.Shopify.designMode) {
        setTimeout(function(){
          try {
            var probe = document.querySelector('.ormuth-stamped-wordmark:not(.ormuth-menumark), .icon.icon-header-cart');
            if (!probe) return;
            var el = findBackdrop(probe); if (!el) return;
            sampleMedia(el, probe.getBoundingClientRect(), function(rgb){
              if (!rgb) { var c = parseColor(getComputedStyle(el).backgroundColor); if (c) rgb = c; }
              if (!rgb) return;
              var hex = rgbHex.apply(null, rgb);
              var b = document.getElementById('ormuth-bg-badge') || document.createElement('div');
              b.id='ormuth-bg-badge';
              b.style.cssText='position:fixed;left:10px;bottom:10px;z-index:2147483647;background:#2b2119;color:#f0e2d0;'+
                'font:12px/1.5 -apple-system,sans-serif;padding:8px 11px;border-radius:5px;box-shadow:0 2px 10px rgba(0,0,0,.4)';
              b.innerHTML='Ormuth marks — sampled backdrop <b style="color:#e5cfbe">'+hex+'</b>'+
                '<br><span style="opacity:.72">paste into Header &rsaquo; “Header marks: locked backdrop colour”</span>'+
                '<span style="display:inline-block;width:13px;height:13px;vertical-align:-2px;margin-left:7px;border:1px solid #6d5242;background:'+hex+'"></span>';
              if (!b.parentNode) document.body.appendChild(b);
            });
          } catch(e){}
        }, 900);
      } /* v37.1: theme-editor re-renders replace the section DOM - re-dedup ids + re-ramp so marks never sit on baked defaults in the customizer */
    }

    /* ==== v36: the O's journey (Joe, Aug 16) ====
       Desktop only. At the top of the page the cart's O mark sits visually at
       the end of the logo lockup (after the crown) — the full five-mark strike.
       Over the first 200px of scroll it glides to its natural top-right cart
       position and docks there permanently for the visit (one-way latch).
       The element never moves in the DOM — it is the real cart button,
       FLIP-transformed from its corner to the lockup, so the count and click
       behavior are untouched. Mobile + reduced-motion: docked from the start. */
    function ormuthCartJourney() {
      if (window.innerWidth < 1025) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var cartSvg = Array.prototype.find.call(document.querySelectorAll('.icon.icon-header-cart'), function(c){ return c.getBoundingClientRect().width > 0; });
      var cart = document.getElementById('cart-link') || (cartSvg && cartSvg.closest('a,button'));
      var crown = Array.prototype.find.call(document.querySelectorAll('.ormuth-crownmark'), function(c){ return c.getBoundingClientRect().width > 0; });
      if (!cart || !crown) return;
      var done = false, dx = 0, dy = 0, D = 200;
      function ease(t){ return 1 - Math.pow(1 - t, 3); }
      function apply() {
        if (done) return;
        var t = Math.min(1, Math.max(0, (window.scrollY || window.pageYOffset) / D));
        if (t >= 1) { done = true; cart.style.transform = ''; cart.style.willChange = ''; return; }
        var e = ease(t);
        cart.style.transform = 'translate(' + (dx * (1 - e)).toFixed(1) + 'px,' + (dy * (1 - e)).toFixed(1) + 'px)';
      }
      function measure() {
        if (done) return;
        var prev = cart.style.transform; cart.style.transform = 'none';
        var cr = crown.getBoundingClientRect(), ca = cart.getBoundingClientRect();
        if (!cr.width || !ca.width) { cart.style.transform = prev; return; }
        var gap = Math.max(6, cr.width * 0.18);
        dx = (cr.right + gap) - ca.left;
        dy = (cr.top + cr.height / 2) - (ca.top + ca.height / 2);
        cart.style.transform = prev;
        apply();
      }
      cart.style.transition = 'none';
      cart.style.willChange = 'transform';
      measure();
      setTimeout(measure, 600);   /* re-measure after fonts/layout settle */
      window.addEventListener('scroll', apply, { passive: true });
      window.addEventListener('resize', function(){ if (!done) setTimeout(measure, 120); });
    }
    function boot() {
      /* one-shot: match whatever is behind the hallmarks as the page opens.
         A backdrop image that has not decoded yet is handled by the load hook
         in refresh(), not by polling — see the note below. */
      refreshAll(true);
      ORMUTH_FIRST_PASS = false;   /* boot sample done — guard is live from here on */
      /* ormuthCartJourney();  <- O-journey DISABLED at Joe's request (Aug 16) — cart is static top-right on all devices. Re-enable by uncommenting this one call. */
      /* v37.8 (Joe, Aug 17: "single sample"). The [400,1000,2500] retry schedule
         meant every page load repainted the marks up to FOUR times — boot, then
         three re-samples — and each repaint shifts their tone slightly. That is
         the residual "flicker" he kept seeing; it was never a rendering bug, it
         was the ramp working three more times than anyone needed to watch.
         Now: sample ONCE at boot. The late-hero case is already covered without
         polling — v37.2 attaches a one-shot 'load' listener to a backdrop <img>
         that was not yet decoded, so a slow hero still gets matched the moment it
         is paintable, and only then. If sampling fails outright the baked warm
         palette in the snippets stands, which is correct-looking everywhere.
         HISTORY — do not reintroduce timed retries: v34.1 added a 5000ms retry
         that landed after the hero slideshow advanced and froze the next (white)
         slide's colour. Anything on a timer risks sampling the wrong frame. */
      /* rotation changes the header layout — take one fresh sample.
         Width-gated: mobile URL-bar show/hide during scroll only changes
         height, so scrolling never re-triggers sampling. */
      if (!IN_EDITOR) return;   /* v38: live site never re-ramps — one pass at boot */
      var lastW = window.innerWidth;
      window.addEventListener('resize', function() {
        if (window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        setTimeout(function(){ refreshAll(true); }, 120);
      });
    }
    /* ==== v39 (Sept 20, 2026): no colour flash on load (Joe: "why does the header
       logo still flicker"). Nothing was sampling: the marks arrive in the HTML painted
       with the palette baked for the home page hero, and this file, loaded with defer,
       only repainted them to the locked colour after the whole page had parsed, so
       every page opened brown and then turned. Now the file is loaded right after the
       header markup, not deferred, and the locked ramp (synchronous, no sampling) runs
       the moment it executes, before the first paint. header.liquid also keeps the
       marks hidden until data-owm-ready is set, with a 1.5s CSS failsafe, so even on
       a cold cache the wrong colours are never shown. boot() still runs afterwards. */
    function markReady() { var h = document.getElementById('SiteHeader'); if (h) h.setAttribute('data-owm-ready', '1'); }
    if (!IN_EDITOR && !ORMUTH_STATIC_COLORS && lockedBg()) {
      try { refreshAll(true); } catch (e) {}
      markReady();
    }
    /* repaint if the viewport crosses the mobile breakpoint (desktop window drag,
       tablet rotation). Not a timer — fires only on an actual breakpoint change. */
    if (ORMUTH_MB_MQ) {
      var onMq = function () { try { refreshAll(true); } catch (e) {} };
      if (ORMUTH_MB_MQ.addEventListener) ORMUTH_MB_MQ.addEventListener('change', onMq);
      else if (ORMUTH_MB_MQ.addListener) ORMUTH_MB_MQ.addListener(onMq);
    }
    function bootThenReady() { try { boot(); } finally { markReady(); } }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootThenReady);
    else bootThenReady();

    /* ---- CART COUNT JS (unchanged from v24/v25) ---- */
    var bagEl = document.getElementById('ormuth-bag-icon');
    var countEl = document.getElementById('ormuth-cart-count');
    if (!bagEl || !countEl) return;
    function updateCart(count) {
      if (count > 0) { bagEl.style.display = 'none'; countEl.style.display = ''; countEl.textContent = count; }
      else { bagEl.style.display = ''; countEl.style.display = 'none'; }
    }
    /* v35 fix: this file is a plain .js asset, so the old liquid interpolation
       ('{{ cart.item_count }}') never rendered — initial count was always 0 and
       the mark showed O even with items in the cart on fresh page loads.
       Fetch the real count at boot instead. */
    updateCart(0);
    refreshCount();
    function refreshCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { updateCart(cart.item_count); })
        .catch(function() {});
    }
    var origFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1)) {
        return origFetch.apply(this, arguments).then(function(response) { setTimeout(refreshCount, 300); return response; });
      }
      return origFetch.apply(this, arguments);
    };
    var origXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1)) {
        this.addEventListener('load', function() { setTimeout(refreshCount, 300); });
      }
      return origXHROpen.apply(this, arguments);
    };
  })();
